export default __webpack_public_path__ + "static/EP_logo_blue-eba58bb049dcebe1de1f75035d69a64b.png";